(() => {
  const successRequested = new URLSearchParams(window.location.search).get('raffle_success') === '1';
  if (!successRequested) return;

  function initSuccess(root = document) {
    root.querySelectorAll('[data-raffle-growhauzz]').forEach((landing) => {
      if (landing.dataset.raffleSuccessReady === 'true') return;

      const section = landing.querySelector('#raffle-form');
      const formContent = section?.querySelector('.rg__form-copy');
      const success = section?.querySelector('[data-raffle-form-success]');
      const countdown = success?.querySelector('[data-raffle-countdown]');
      if (!section || !formContent || !success) return;

      landing.dataset.raffleSuccessReady = 'true';
      formContent.hidden = true;
      success.hidden = false;
      section.classList.add('is-success');

      const storageKey = 'growhauzz-raffle-code-expiry';
      let expiresAt = 0;

      try {
        expiresAt = Number(window.sessionStorage.getItem(storageKey));
      } catch (_error) {
        expiresAt = 0;
      }

      if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
        expiresAt = Date.now() + 24 * 60 * 60 * 1000;
        try {
          window.sessionStorage.setItem(storageKey, String(expiresAt));
        } catch (_error) {
          // The countdown still works when browser storage is unavailable.
        }
      }

      const updateCountdown = () => {
        if (!countdown) return;

        const remaining = Math.max(0, expiresAt - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        countdown.textContent = remaining > 0
          ? `Code expires in ${hours}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`
          : 'Code has expired';
      };

      updateCountdown();
      window.setInterval(updateCountdown, 1000);

      success.addEventListener('click', async (event) => {
        const copyButton = event.target.closest('[data-inline-copy]');
        if (!copyButton) return;

        const code = copyButton.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
        } catch (_error) {
          const input = document.createElement('textarea');
          input.value = code;
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }

        const label = copyButton.querySelector('span');
        if (!label) return;

        label.textContent = 'Copied!';
        window.setTimeout(() => {
          label.innerHTML = '<b aria-hidden="true">▣</b> Copy';
        }, 1800);
      });

      window.requestAnimationFrame(() => {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        success.focus({ preventScroll: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSuccess(), { once: true });
  } else {
    initSuccess();
  }

  document.addEventListener('shopify:section:load', (event) => initSuccess(event.target));
})();
